<template>
<!-- <CompanyPolicy></CompanyPolicy> -->
<div class="col-xxl-12 mb-5">
    <!-- <ECShopAdvisory></ECShopAdvisory> -->
  </div>
  <div class="col-xxl-12 mb-5">
    <!-- <BalanceDetails
      widget-classes="card-xxl-stretch mb-5 mb-xxl-8"
    ></BalanceDetails> -->
  </div>
  <div class="col-xxl-12">
      <UnilevelHistory
        widget-classes="card-xxl-stretch mb-5 mb-xxl-8"
      ></UnilevelHistory>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import UnilevelHistory from "@/components/unilevel/UnilevelHistory.vue";
// import BalanceDetails from "@/components/cards/BalanceDetails.vue";
// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";
// import ECShopAdvisory from "@/views/ECShopAdvisory.vue";

export default defineComponent({
  name: "unilevel",
  components: {
    UnilevelHistory,
    // BalanceDetails,
    // CompanyPolicy,
    // ECShopAdvisory
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("unilevelTab") || "0");
      setCurrentPageTitle("Unilevel");

    });
    
  }
});
</script>
